__turbopack_context__.v({
  "labels": "PartnerLoader-module__IuaffW__labels",
  "mapReviewPanelProgress": "PartnerLoader-module__IuaffW__mapReviewPanelProgress",
  "mapReviewPanelProgressContainer": "PartnerLoader-module__IuaffW__mapReviewPanelProgressContainer",
  "progressBar": "PartnerLoader-module__IuaffW__progressBar",
  "progressBarContainer": "PartnerLoader-module__IuaffW__progressBarContainer",
  "topBarProgress": "PartnerLoader-module__IuaffW__topBarProgress",
  "topBarProgressContainer": "PartnerLoader-module__IuaffW__topBarProgressContainer",
});
